(function() {
    angular
        .module("app")
        .controller("DeleteModalController", DeleteModalController)

    DeleteModalController.$inject = [
        "$rootScope",
        "$scope",
        "$uibModalInstance",
        "objectID",
        "objectName"
    ]

    /**
        @param $rootScope
        @param $scope
        @param $uibModalInstance
        @param objectID
        @param objectName
        @constructor
     **/
    function DeleteModalController(
        $rootScope,
        $scope,
        $uibModalInstance,
        objectID,
        objectName
    ){
        "use strict"

        /** @type {boolean} */
        $rootScope.preventStateChange = false

        /** @type {integer} */
        $scope.id = objectID

        /** @type {string} */
        $scope.confirmationText = "Are you sure you want to delete this " + objectName + "?"

        /**
            @returns {void}
         **/
        $scope.ok = function() {
            $uibModalInstance.close()
        }

        /**
            @returns {void}
         **/
        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
